import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { UserPreference } from '../models';
import { UserPreferenceService } from './user-preference.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  static LanguageKey = 'language';
  static DefaultLanguage = 'en-GB';
  skipUserPreferenceService = false;
  currentLanguage: string;

  constructor(
    @Inject(LOCALE_ID) private language: string,
    private userPreferenceService: UserPreferenceService,
    private localStorageService: LocalStorageService,
  ) {}

  getLanguage(): Observable<string> {
    return (
      this.skipUserPreferenceService ? of(undefined) : this.userPreferenceService.get(LanguageService.LanguageKey)
    ).pipe(
      map((userPreference: UserPreference) => {
        let language = userPreference?.value;
        if (!language) {
          language = localStorage.getItem(LanguageService.LanguageKey) ?? LanguageService.DefaultLanguage;
          if (!this.skipUserPreferenceService) {
            this.userPreferenceService.set(LanguageService.LanguageKey, language).subscribe();
          }
        }
        const localLanguage = this.localStorageService.getString(LanguageService.LanguageKey);
        if (localLanguage != language) {
          this.setLanguage(language).subscribe();
        }

        this.currentLanguage = language;
        return language;
      }),
    );
  }

  setLanguage(language: string): Observable<any> {
    this.localStorageService.setString(LanguageService.LanguageKey, language);
    return (
      this.skipUserPreferenceService
        ? of(undefined)
        : this.userPreferenceService.set(LanguageService.LanguageKey, language)
    ).pipe(tap(() => location.reload()));
  }

  translate(value: string, valueAbbreviation: string): string {
    return this.language === LanguageService.DefaultLanguage && valueAbbreviation ? valueAbbreviation : value;
  }

  get locale(): string {
    return this.currentLanguage;
  }

  get isUS(): boolean {
    return this.currentLanguage === 'en-US';
  }
}
